import React from "react";
import CustomerAddToolsSerialForm from "./CustomerAddToolsSerialForm";
import MainPageCompenent from './MainPageCompenent';
function CustomerAddToolsSerial(props) {
    return (
        <MainPageCompenent>
            <CustomerAddToolsSerialForm />
        </MainPageCompenent>
    );
}

export default CustomerAddToolsSerial;